module.exports = __webpack_public_path__ + "DAZicon.png?05a24c6f9cd54d4fe22ed35b0b4cdae6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/DAZicon.png
// module id = 36
// module chunks = 0